export interface StartupMetricEntry {
    name: string
    timeMs: number
    detail?: unknown
}

export interface StartupMetricsStore {
    marks: StartupMetricEntry[]
}

function getStartupMetricsStore(): StartupMetricsStore | null {
    if (typeof window === 'undefined' || typeof performance === 'undefined') {
        return null
    }

    if (!window.__KNOV_STARTUP_METRICS__) {
        window.__KNOV_STARTUP_METRICS__ = { marks: [] }
    }

    return window.__KNOV_STARTUP_METRICS__
}

export function markStartupMetric(name: string, detail?: unknown) {
    const store = getStartupMetricsStore()
    if (!store) return null

    const entry: StartupMetricEntry = {
        name,
        timeMs: performance.now(),
        detail,
    }

    store.marks.push(entry)

    try {
        performance.mark(`knov:${name}`)
    } catch (_) {}

    try {
        window.dispatchEvent(new CustomEvent('knov-startup-metric', { detail: entry }))
    } catch (_) {}

    return entry
}

export function getStartupMetricsSnapshot(): StartupMetricEntry[] {
    const store = getStartupMetricsStore()
    return store ? [...store.marks] : []
}
